import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const List18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 1.25C0.809644 1.25 0.25 1.80964 0.25 2.5V6.5C0.25 7.19036 0.809644 7.75 1.5 7.75H5.5C6.19036 7.75 6.75 7.19036 6.75 6.5V2.5C6.75 1.80964 6.19036 1.25 5.5 1.25H1.5ZM1.75 6.25V2.75H5.25V6.25H1.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 10.25C0.809644 10.25 0.25 10.8096 0.25 11.5V15.5C0.25 16.1904 0.809644 16.75 1.5 16.75H5.5C6.19036 16.75 6.75 16.1904 6.75 15.5V11.5C6.75 10.8096 6.19036 10.25 5.5 10.25H1.5ZM1.75 15.25V11.75H5.25V15.25H1.75Z'
      fill='currentColor'
    />
    <path d='M18 3.75H9V2.25H18V3.75Z' fill='currentColor' />
    <path d='M9 6.75H16V5.25H9V6.75Z' fill='currentColor' />
    <path d='M18 12.75H9V11.25H18V12.75Z' fill='currentColor' />
    <path d='M9 15.75H16V14.25H9V15.75Z' fill='currentColor' />
  </Svg>
);

List18.displayName = 'List18';
export default List18;
